import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25dc3b90")

_pushScopeId("data-v-25dc3b90")
const _hoisted_1 = { class: "row gy-5 g-xl-8 mb-5 mb-xl-10 tableOpacity" }
const _hoisted_2 = { class: "card order-widget card-p d-flex flex-wrap align-items-center justify-content-between flex-row" }
const _hoisted_3 = { class: "w-75" }
const _hoisted_4 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "40%",
  height: "26"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "45%",
  height: "21"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "70",
  rx: ".5rem",
  ry: ".5rem",
  width: "25%",
  height: "38"
}, null, -1)
const _hoisted_7 = { class: "w-25 text-end" }
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "15",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "82",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "20"
}, null, -1)
const _hoisted_10 = { class: "row gy-5 gx-xl-8 mb-5 mb-xl-10 tableOpacity" }
const _hoisted_11 = { class: "col-xxl-12" }
const _hoisted_12 = { class: "card order-widget card-p" }
const _hoisted_13 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "8%",
  height: "26"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "12%",
  height: "21"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "90",
  rx: ".5rem",
  ry: ".5rem",
  width: "400",
  height: "310"
}, null, -1)
const _hoisted_17 = { class: "row gy-5 gx-xl-8 mb-5 mb-xl-10 tableOpacity" }
const _hoisted_18 = { class: "col-xxl-12" }
const _hoisted_19 = { class: "card order-widget card-p" }
const _hoisted_20 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "8%",
  height: "26"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "12%",
  height: "21"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "90",
  rx: ".5rem",
  ry: ".5rem",
  width: "400",
  height: "310"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
        return _createVNode("div", {
          class: "col-xxl-4",
          key: i
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_content_loader, {
                viewBox: "0 0 400 112",
                preserveAspectRatio: "none",
                width: "100%",
                height: "112",
                speed: 2,
                primaryColor: "#3E3E3E",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_content_loader, {
                width: "56",
                height: "112",
                speed: 2,
                primaryColor: "#3E3E3E",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ])
        ])
      }), 64))
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_content_loader, {
            viewBox: "0 0 400 400",
            preserveAspectRatio: "none",
            width: "100%",
            height: "400",
            speed: 2,
            primaryColor: "#3E3E3E",
            secondaryColor: "#cccccc"
          }, {
            default: _withId(() => [
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_content_loader, {
            viewBox: "0 0 400 400",
            preserveAspectRatio: "none",
            width: "100%",
            height: "400",
            speed: 2,
            primaryColor: "#3E3E3E",
            secondaryColor: "#cccccc"
          }, {
            default: _withId(() => [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
})